module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXCAYAAAAP6L+eAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQaEKjoXHUAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAA6ElEQVRIS72SMQ7CMBRDs1NOAYwMDCwguAMTCxL3P0XBIY7Mz6dtIgVLX01t/6e2EOa0HoYxHbM8r1pdwABcj+dRQZ5XJQJ+gZvhXcC6PAXerLZ9wDhr5uqy37nLNWA9Z7WCkx1VgGEAzECXl4Lpq1eYuKpHH/J8ekWfQTbeYkE9yvo4E/x83D+Zmha+VC5DzdvpUA3mPnYJzWANoylirpOiKNwTSnCKvl9FA/U5+u+BbEczF4yrXbIdyPY0i2Ih3RZPouN1recKBQD02+m0/MhRBM9NNfxvYLy6/SzoVIMhLk5NqjoK4QUAaV3R19xEFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/hunter-icon.png
// module id = 495
// module chunks = 0